var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Gang({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8587 2.6665C12.5867 2.6665 11.5557 3.71106 11.5557 4.99984V42.9998C11.5557 44.2886 12.5867 45.3332 13.8587 45.3332H50.1415C51.4136 45.3332 52.4445 44.2886 52.4445 42.9998V4.99984C52.4445 3.71106 51.4136 2.6665 50.1415 2.6665H13.8587ZM50.8612 42.4452C50.8612 43.2993 50.4554 43.71 49.6137 43.71H14.3865C13.5441 43.71 13.139 43.2993 13.139 42.4452V5.55451C13.139 4.70118 13.5441 4.28969 14.3865 4.28969H49.6137C50.4554 4.28969 50.8612 4.70118 50.8612 5.55451V42.4452ZM39.3097 12.9828C39.3097 12.1949 38.6679 11.5554 37.8771 11.5554C37.0849 11.5554 36.4446 12.1949 36.4446 12.9828V38.5724C36.4446 39.3604 37.0849 39.9998 37.8771 39.9998C38.6679 39.9998 39.3097 39.3604 39.3097 38.5724V12.9828ZM46.4208 12.9828C46.4208 12.1949 45.779 11.5554 44.9883 11.5554C44.196 11.5554 43.5557 12.1949 43.5557 12.9828V38.5724C43.5557 39.3604 44.196 39.9998 44.9883 39.9998C45.779 39.9998 46.4208 39.3604 46.4208 38.5724V12.9828ZM36.6278 6.26071C36.2046 6.26071 35.8612 6.6243 35.8612 7.0723C35.8612 7.52111 36.2046 7.8839 36.6278 7.8839H46.0369C46.46 7.8839 46.8034 7.52111 46.8034 7.0723C46.8034 6.6243 46.46 6.26071 46.0369 6.26071H36.6278Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Gang);
export default __webpack_public_path__ + "static/media/2Gang.39d370a35c77dc8f74c6f6db2c0fed7c.svg";
export { ForwardRef as ReactComponent };